/**
 * Why a display aid drawn on the active structure set cannot draw while the
 * set sits on no view, as a message id: the set's image is not in the
 * viewport, so there is nothing to draw on. A control refuses the aid with
 * it, and one that is on but has nothing to draw on shows it for the state
 * it is in, so an absent overlay never reads as a clean match.
 */
export const STRUCTURE_SET_NOT_SHOWN_HINT_ID =
    'tool.disabled.structureSetNotShown';
